import { render, staticRenderFns } from "./BtnMostrarEventos.vue?vue&type=template&id=2160b402"
import script from "./BtnMostrarEventos.vue?vue&type=script&lang=js"
export * from "./BtnMostrarEventos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports